import Vue from 'vue';
import Router from 'vue-router';
import { setHtmlMeta } from '@/utils/utils';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return originalPush.call(this, to).catch(e => {
    if (e.name == 'NavigationDuplicated') location.reload(false);
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return originalReplace.call(this, to).catch(e => {
    if (e.name == 'NavigationDuplicated') location.reload(false);
  });
};

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/tax/2022',
    },
    {
      path: '/tax/2022',
      name: 'Tax2022',
      component: () => import(/* webpackChunkName: "tax" */ './views/2022-tax/index.vue'),
      meta:{
        title: '约克论坛2022加拿大报税专题',
        keywords: '报税攻略,加拿大2022报税攻略,约克论坛报税专题,加拿大报税,报税攻略,新移民报税,留学生报税,自雇报税,小生意报税,报税',
        description: '2022年加拿大报税季又来了，约克论坛为大家整理了一份超详细的报税攻略！无论你是新移民，留学生，自雇小生意人士还是公司代表，打开约克论坛2022加拿大报税专题，这里就有你最需要的报税攻略！超多干货，等你解锁！',
      }
    },
    {
      path:'/spring_2022',
      name:'Spring2022',
      component:() => import(/* webpackChunkName: "spring_2022" */ './views/2022-spring/index.vue'),
      meta:{
        title:'约克论坛-2022赏樱踏春“随手拍 晒春天',
        keywords:'摄影，春季摄影，活动，樱花，春天',
        description:'用相机定格疫情下的春天！约克论坛 “随手拍 晒春天”活动，等你分享2022年的春天~'
      }
    },
    {
      path:'/school_2022',
      name:'BeginSchool',
      component:() => import(/* webpackChunkName: "spring_2022" */ './views/2022-begin-school/index.vue'),
      meta:{
        title:'约克论坛-2022Back To School，加油开学季！',
        keywords:'加拿大学校开学,开学优惠,租房,租房攻略,留学生住宿,手机优惠,网络优惠,开学活动,约克论坛开学季,开学注意事项,',
        description:'9月开学季，约克论坛与您一起奔赴人生道路的每一个新起点，新目标。在这里许下对学习、对工作、对人生新的展望，冲鸭！我们永远都是勇敢的少年~'
      }
    },
    {
      path:'/special/covid19',
      name:'OutbreakIndex',
      component:()=> import(/* webpackChunkName: "outbreak" */ './views/outbreak/index.vue'),
      meta:{
        title:'加拿大新冠疫情实时数据',
        keywords:'加拿大疫情,COVID-19,疫情,疫情动态,疫情数据,疫情趋势,确诊病例,新冠肺炎,新冠病毒,新型冠状病毒,加拿大,安省,安大略,多伦多,BC省,温哥华,魁省,魁北克,蒙特利尔,阿省,卡加里尔',
        description:'约克论坛24小时关注加拿大新型冠状病毒COVID-19的动态，及时更新加拿大最新的疫情数据，包括安省、BC省、魁省、阿省在内的多个省份的的疫情趋势，尽晓加国疫情动态。'
      }
    },
    {
      path:'/brilliant_reply',
      name:'BrilliantReply',
      component:()=> import(/* webpackChunkName: "BrilliantReply" */ './views/brilliant_reply/index.vue'),
      meta:{
        title:'搜罗加拿大热门话题，尽在约克论坛精彩神回复',
        keywords:'约克论坛神回复,多伦多新鲜事,多伦多热门话题,精彩回复,神回复',
        description:'汇集加拿大热门话题讨论，搜集大家都爱看的神回复，为你提供约克论坛上最有看点的精彩评论。'
      }
    },
    {
      path:'/food_2022',
      name:'Food2022',
      component:()=> import(/* webpackChunkName: "food_2022" */ './views/2022-food/index.vue'),
      meta:{
        title:'多伦多美食种草-约克论坛',
        keywords:'多伦多美食,多伦多美食种草,美食活动,有奖活动,我的拿手菜,多伦多美食探店,晒我家娃的学生午餐,多伦多好吃的零食,方便面大比拼,yorkbbs,约克论坛,加拿大,多伦多',
        description:'美食制作、美味测评、趣味探店……快来约克论坛分享你的美食体验吧！约克论坛联系众多本地美食达人发起#多伦多美食种草#活动，发布美食相关的图文/视频就有机会获得惊喜礼物哦',
      }
    },
    {
      path:'/autumn_2022',
      name:'Photo2022',
      component:()=> import(/* webpackChunkName: "photo_2022" */ './views/2022-photo/index.vue'),
      meta:{
        title:'2022加拿大的秋“随手拍晒秋天”-约克论坛',
        keywords:'加拿大枫叶,秋季赏枫,赏枫路线,赏枫景点,枫叶地图,枫叶火车,赏枫攻略,赏枫地点推荐,枫叶观赏时间,阿岗昆枫叶,安省赏枫好去处,热门赏枫路线,加拿大秋游,热门赏枫路线,约克论坛活动,约克论坛摄影活动,yorkbbs,约克论坛,加拿大,多伦多',
        description:'转眼夏天变成故事，秋季变成风景，醉美枫叶最美加拿大，深秋枫叶红如晚霞，仿佛夏日里怒放的火红花朵，快来约克论坛分享你用镜头记录的美丽秋景吧，发布视频/图文就有机会获得惊喜礼物哦~ ',
      }
    },
    {
     
      path:'/fifaworldcup',
      name:'WorldCupCurrency2022',
      component:()=>import(/* webpackChunkName: "fifaworldcup" */ './views/2022-world-cup/currency.vue'),
      meta:{
        title:'激情世界杯！聊世界杯上YorkBBS -新闻列表- 约克论坛 ',
        keywords:'2022世界杯,世界杯新闻,球况,世界杯,竞猜,足球竞猜,世界杯专题,赌球,世界杯赛程,足球,足球比赛,世界杯冠军,世界杯直播,世界杯比赛,约克论坛,YorkBBS',
        description:'谁是最强预测帝？竞猜世界杯，约克论坛为您加点料！与全加拿大华人小伙伴一起看球聊球的，这里有最热最新的世界杯新闻信息、世界杯话题帖子以及最新的赛事播报。',
      }
    },
    {
     
      path:'/fifaworldcupvip',
      name:'WorldCupGold2022',
      component:()=>import(/* webpackChunkName: "fifaworldcup" */ './views/2022-world-cup/gold.vue'),
      redirect:'/fifaworldcup',
      meta:{
        title:'激情世界杯！聊世界杯上YorkBBS -新闻列表- 约克论坛 ',
        keywords:'2022世界杯,世界杯新闻,球况,世界杯,竞猜,足球竞猜,世界杯专题,赌球,世界杯赛程,足球,足球比赛,世界杯冠军,世界杯直播,世界杯比赛,约克论坛,YorkBBS',
        description:'谁是最强预测帝？竞猜世界杯，约克论坛为您加点料！与全加拿大华人小伙伴一起看球聊球的，这里有最热最新的世界杯新闻信息、世界杯话题帖子以及最新的赛事播报。',
      }
    },
    {
     
      path:'/fifaschedule',
      name:'FifaSchedule2022',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2022-fifa-schedule/main.vue'),
      meta:{
        title:'激情世界杯！聊世界杯上YorkBBS -最新赛程- 约克论坛',
        keywords:'2022世界杯,世界杯新闻,球况,世界杯,竞猜,足球竞猜,世界杯专题,赌球,世界杯赛程,足球,足球比赛,世界杯冠军,世界杯直播,世界杯比赛,约克论坛,YorkBBS',
        description:'谁是最强预测帝？竞猜世界杯，约克论坛为您加点料！与全加拿大华人小伙伴一起看球聊球的，这里有最热最新的世界杯新闻信息、世界杯话题帖子以及最新的赛事播报。',
      }
    },
    {
     
      path:'/food_02',//路由规则 https://media2.imgyb.xyz/media/v1/image/d77f277622bea12a73b2b95b378e0894.png
      name:'Christmas2022',
      component:()=>import(/* webpackChunkName: "food_02" */ './views/2022_christmas/main.vue'),
      meta:{
        title:'玩味圣诞 分享美食-约克论坛',
        keywords:'多伦多美食,多伦多美食种草,美食活动,有奖活动,我的拿手菜,多伦多美食探店,圣诞节,圣诞活动,圣诞美食,yorkbbs,约克论坛,加拿大,多伦',
        description:'美食制作、美味测评、趣味探店……快来约克论坛分享你的美食体验吧！围绕主题 # 玩味圣诞 #分享美食，发布相关的图文/视频就有机会获得500加币圣诞大餐哦',
      }
    },
    {
      path:'/food_03',
      name:'NewYear2023',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2023-china-year/main.vue'),
      meta:{
        title:'寻找年味，一起聊聊过年那些事儿-约克论坛',
        keywords:'欢喜过大年，万象更新又一年。约克论坛“过新年”征集活动开启啦！以# 寻找年味儿 #为主题，通过本专题页面发布图文/视频帖子，一起聊聊过年那些事儿~',
        description:'过年,春节,过年活动,多伦多春节活动,华人活动,多伦多约克论坛活动,约克论坛,YorkBBS,多伦多',
      }
    },
    {
      path:'/discussion/:id',
      name:'SubjectDetail',
      component:()=>import(/* webpackChunkName: "SubjectDetail" */ './views/discussion/subject.vue'),
    },
    {
      path:'/hashtag/:name',
      name:'HashtagPage',
      component:()=>import(/* webpackChunkName: "HashtagPage" */ './views/hashtag/index.vue'),
    },
    {
      path:'/spring_2023',
      name:'SpringPhotograph2023',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2023-spring-photograph/main.vue'),
      meta:{
        title:'记录多伦多春天随手拍-约克论坛',
        keywords:'多伦多春天,加拿大春天,约克论坛,随手拍晒春天,记录多伦多春天,春季踏青,多伦多春季出游,多伦多春天去哪儿玩,多伦多春季活动,yorkbbs,约克论坛活动,约克论坛春季活动,约克论坛晒图活动,约克论坛有奖活动',
        description:'年年岁岁花相似，岁岁年年人不同 。最是一年春好处，愿不负韶光，不负自己！快来约克论坛参与话题#记录多伦多春天 随手拍#发帖，就有机会获得惊喜哦~',
      }
    },
    {
      path:'/spring/travel/2023',
      name:'SpringTravel2023',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2023-spring-travel/main.vue'),
      meta:{
        title:'一起春游去，有阳光的日子不宅家！-约克论坛',
        keywords:'多伦多野餐,多伦多户外烧烤,多伦多周边一日游,多伦多骑行路线,多伦多公园散步,多伦多周末遛娃,多伦多度假屋,记录多伦多春天,春季踏青,多伦多春季出游,多伦多春天去哪儿玩,多伦多春季活动,yorkbbs,约克论坛活动,约克论坛春季活动,约克论坛晒图活动,约克论坛有奖活动',
        description:'在明媚的5月，有阳光的日子不宅家！一场野餐或户外烧烤、周边一日游、骑行、公园散步、周末遛娃、度假屋等，约克论坛邀您一起记录精彩瞬间，还有机会获得惊喜哦',
      }
    },
    {
      path:'/children/day/2023',
      name:'ChildrenDay2023',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2023-children-day/main.vue'),
      meta:{
        title:'晒我家的娃，这一瞬间感觉都值得！-约克论坛',
        keywords:'晒娃活动,晒照活动,多伦多活动,yorkbbs,约克论坛活动,约克论坛春季活动,约克论坛晒图活动,约克论坛有奖活动',
        description:'每个宝贝成长努力的瞬间，都是父母人生中的宝贵记忆~养娃不易，晒下让你心暖的瞬间，写写让你抓狂的日常',
      }
    },
    {
      path:'/summer/travel/2023',
      name:'SummerTravel2023',
      component:()=>import(/* webpackChunkName: "photo_2022" */ './views/2023-summer-travel/main.vue'),
      meta:{
        title:'夏日的美好，吃喝玩乐嗨翻天-约克论坛',
        keywords:'夏天和什么最配？约克论坛邀您一起记录夏日美好，发帖参与话题#开心一夏#，与广大网友一起你心中和夏天最配的美食和好玩的地方吧，还有机会获得惊喜哦~ ',
        description:'多伦多夏天,加拿大夏天,约克论坛,夏日美食,夏日好去处,随手拍晒夏天,记录多伦多夏天,夏季出游,多伦多夏天去哪儿玩,多伦多夏季活动,yorkbbs,约克论坛活动,约克论坛春季活动,约克论坛晒图活动,约克论坛有奖活动',
      }
    },
    {
      path:'/christmas/2023',
      name:'Christmas2023',
      component:()=>import(/* webpackChunkName: "Christmas2023" */ './views/2023-christmas/main.vue'),
      meta:{
        title:'“庆圣诞迎新年”分享你的精彩瞬间-约克论坛',
        keywords:'加拿大圣诞节,加拿大新年,圣诞美食,圣诞好去处,圣诞去哪儿玩,圣诞吃什么,新年好去处,跨年活动,加拿大跨年活动,约克论坛活动,约克论坛摄影活动,yorkbbs,约克论坛,加拿大,多伦多',
        description:'Merry Christmas and Happy New Year ！上传照片分享你的圣诞树、圣诞美食以及2023美好回忆，让我们一起创造属于我们的节日快乐记忆，憧憬2024的美好！',
      }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: "core_forum" */ '@/common/404/index.vue'),
      meta: { desc: '404' },
    },
    {
      path:'*',
      redirect:'/tax/2022'
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta) {
    setHtmlMeta(to.meta);
  }
  next();
});

export default router;
